import { Music } from 'lucide-react';

/**
 * Neutral stand-in shown wherever campaign artwork is missing. Nothing is
 * bundled or fetched; it is a muted block sized by its container.
 */

type Props = {
    className?: string;
};

const ArtworkPlaceholder = ({ className = '' }: Props) => {
    return (
        <div className={`artwork-placeholder ${className}`.trim()} aria-hidden="true">
            <Music />
        </div>
    );
};

export default ArtworkPlaceholder;
